// @vendors
const { connect } = require('react-redux');
// @components
const ChatSendMessage = require('./ChatSendMessage');
// @actions
const chatActions = require('actions/chat');

const mapStateToProps = (state) => ({
    maximumMessageLength: state.okChat.getIn(['options', 'maximumMessageLength'], null),
    showCloseQuestion: state.okChat.get('showCloseQuestion'),
    msgReceiveFail : state.okChat.get('msgReceiveFail'),
    timer: state.okChat.get('timer')
});

const mapDispatchToProps = ({
    sendMessage: chatActions.sendMessage,
    startConversation: chatActions.startConversation
});

const ChatSendMessageContainer = connect(mapStateToProps, mapDispatchToProps)(ChatSendMessage);

module.exports = ChatSendMessageContainer;